import type { MemberSide, ProjectMemberRow } from '@/features/projects/types'

/**
 * Fail closed: a caller the roster does not place on a side is offered
 * neither side's act; the server's gate is the real refusal either way.
 *
 * `null` when `principalKey` is `null`, when no roster row's `userId`
 * matches it, or when the matching row carries no `side` — the same
 * refusal for all three, by design (deferred-findings finding 6).
 */
export function callerSide(
  members: readonly ProjectMemberRow[] | null | undefined,
  principalKey: string | null
): MemberSide | null {
  if (principalKey === null) return null
  const own = (members ?? []).find((m) => m.userId === principalKey)
  return own?.side ?? null
}
